import React, { useContext, useMemo } from 'react';
import { Checkbox } from '@material-ui/core';
import { MODAL_KEY, RESPONSE_POPUP_KEY, CONFIRMATION_POPUP_KEY, ADD_NOTE } from '../../../constants/patientChart.constant';
import { POPUP_TYPE } from '../../subComponents/popup';
import PPButton from '../../subComponents/button';
import { PatientChartContext } from '../../../contexts/patientChart';

export const AddNote = ({
  orderId = 0,
  patientId = 0,
  addNote: addNoteAction = async (requestBody = {}) => {},
  getNotesTabInfo = async () => {},
}) => {
  const {
    addNote,
    setAddNote,
    loading,
    setLoading,
    handleModalOpen,
    handleMultipleModalClose,
  } = useContext(PatientChartContext);

  const handleNoteTextChange = ({ target }) => {
    setAddNote({ ...addNote, noteText: target.value });
  };

  const handleAddPatientNoteChange = (_, addPatientNote = false) => {
    setAddNote({ ...addNote, addPatientNote });
  };

  const handleAddNote = async ({ key }) => {
    const requestBody = {
      OrderId: orderId,
      PatientId: patientId,
      NoteText: addNote.noteText,
      AddPatientNote: addNote.addPatientNote,
    };

    const _loading = new Set(loading);
    _loading.add(MODAL_KEY.ADD_NOTE);
    setLoading(_loading);

    try {
      const { status, data } = await addNoteAction(requestBody);
      if (status === 200) {
        setAddNote(ADD_NOTE());
        handleMultipleModalClose.call(this, { keys: [key, MODAL_KEY.ADD_NOTE] });

        // reload the notes
        getNotesTabInfo();
      }

      if (status !== 200) {
        const { Error: error = 'Failed to add note. Please try later.' } = data;
        const heading = 'Error';

        handleModalOpen({
          key: RESPONSE_POPUP_KEY.ADD_NOTE,
          modal: {
            heading,
            type: POPUP_TYPE.ERROR,
            message: error,
          }
        });
      }
    } catch (e) {
      // error handling when needed
    } finally {
      const __loading = new Set(_loading);
      __loading.delete(MODAL_KEY.ADD_NOTE);
      setLoading(__loading);
    }
  };

  const Template = (
    <div className='flex flex-column flex-fill m-b-5'>
      <div className='flex flex-fill align-items-center m-b-5'>
        <label className="input-label min-width-90 m-r-4">Order Note:</label>
        <textarea
          name='note'
          className='flex flex-fill border-light-grey-1 min-height-160 height-full p-4 font-proxima-nova font-14 color-dark-grey border-box resize-none'
          wrap='soft'
          maxLength={4000}
          value={addNote.noteText}
          onChange={handleNoteTextChange}
        />
      </div>

      <div className='flex align-items-center'>
        <label className="input-label m-r-4">Also, add this as a patient note:</label>
        <Checkbox
          title="sendTextToPatient"
          className='checkbox'
          inputProps={{ 'aria-label': 'primary checkbox' }}
          checked={addNote.addPatientNote}
          onChange={handleAddPatientNoteChange}
        />
      </div>
    </div>
  );

  const _disabled = useMemo(() => (addNote.noteText.length === 0), [addNote]);
  const _loading = useMemo(() => loading.has(MODAL_KEY.ADD_NOTE), [loading]);

  const Actions = (
    <div className='flex justify-content-flex-end'>
      <PPButton label='Add Note' variant='contained' loading={_loading} disabled={_disabled} endGutter onClick={handleAddNote.bind(this, { key: CONFIRMATION_POPUP_KEY.ADD_NOTE, modal: {} })} />
      <PPButton label='Cancel' variant='cancel' disabled={_loading} onClick={handleMultipleModalClose.bind(this, { keys: [MODAL_KEY.ADD_NOTE] })} />
    </div>
  );

  return (
    <div className='flex flex-column flex-fill m-5 patient-chart-container'>
      {Template}
      {Actions}
    </div>
  );
};

export default AddNote;
